import { Checkbox, CheckboxGroup } from "@heroui/react";
import { CircleIcon } from "@phosphor-icons/react";
import clsx from "clsx";
import { TagColor } from "../types";
import { getTagColorClassName } from "../utils";

interface Tag {
  id: string | number;
  name: string;
  color: TagColor | null;
}

interface TagsListProps {
  tags: Tag[];
  selectedTags: string[];
  onCheckboxChange: (selectedTagsIds: string[]) => void;
  filterText?: string;
}

export function TagsList({ tags, selectedTags, onCheckboxChange, filterText = "" }: TagsListProps) {
  // Filter tags based on the input text
  const filteredTags = filterText
    ? tags.filter((tag) => tag.name.toLowerCase().includes(filterText.toLowerCase()))
    : tags;

  if (tags.length === 0) {
    return <p className="text-default-500 text-center">No tags</p>;
  }

  if (filteredTags.length === 0 && filterText) {
    return <p className="text-default-500 mb-2 text-center">No tags found matching "{filterText}"</p>;
  }

  return (
    <CheckboxGroup
      classNames={{ wrapper: "gap-0" }}
      aria-label="Note tags"
      value={selectedTags}
      onChange={onCheckboxChange}
    >
      {filteredTags.map((tag, index) => (
        <Checkbox
          autoFocus={index === 0 && !filterText}
          className="hover:bg-default-100 m-0 min-w-full rounded-lg py-1 transition-colors"
          classNames={{ base: "w-full", label: "w-full" }}
          key={tag.id}
          value={tag.id.toString()}
        >
          <div className="flex items-center gap-1">
            <CircleIcon className={clsx(getTagColorClassName(tag.color))} weight="duotone" />
            {tag.name}
          </div>
        </Checkbox>
      ))}
    </CheckboxGroup>
  );
}
